module.exports = __webpack_public_path__ + "static/mass-1b1187598693831e6300f27cd189b1fa.jpg";